import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header';
import { FooterComponent } from './shared/components/footer/footer';
import { ToastComponent } from './shared/components/toast/toast';

import { TranslateService } from '@ngx-translate/core';
import { WhatsAppButtonComponent } from './shared/components/whatsapp-button/whatsapp-button';



@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, ToastComponent, WhatsAppButtonComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('Tour Enduro Marghine');

  constructor(private translate: TranslateService) {
    console.log('--- ANGULAR APP STARTED --- (Check Browser Console for these logs)');
    this.translate.setDefaultLang('it');
    this.translate.use('it');
  }
}
